import React from "react";
import { useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  LeftContent,
  BreadcrumbContainer,
  BreadcrumbItem,
  BreadcrumbSeparator,
  HeaderTitle,
  DescricaoHeader
} from "./styles";

export default function Header({ title, description, breadcrumbMain, breadcrumbCurrent }) {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <LeftContent>
        <HeaderTitle>{title}</HeaderTitle>
        <DescricaoHeader>{description}</DescricaoHeader>
      </LeftContent>

      <BreadcrumbContainer>
        <BreadcrumbItem
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/oportunidades")}
        >
          {breadcrumbMain}
        </BreadcrumbItem>

        <BreadcrumbSeparator>›</BreadcrumbSeparator>

        <BreadcrumbItem active>{breadcrumbCurrent}</BreadcrumbItem>
      </BreadcrumbContainer>
    </HeaderContainer>
  );
}
